/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Ui_Gesture_MoreInputs */

const en_us2_ui_gesture_more = /** @type {(inputs: Ui_Gesture_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`More ${i?.label}`)
};

const pt_br2_ui_gesture_more = /** @type {(inputs: Ui_Gesture_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mais ${i?.label}`)
};

const es_419_ui_gesture_more = /** @type {(inputs: Ui_Gesture_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Más ${i?.label}`)
};

const pt_pt2_ui_gesture_more = /** @type {(inputs: Ui_Gesture_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mais ${i?.label}`)
};

const fr_fr2_ui_gesture_more = /** @type {(inputs: Ui_Gesture_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Plus de ${i?.label}`)
};

const de_de2_ui_gesture_more = /** @type {(inputs: Ui_Gesture_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mehr ${i?.label}`)
};

const it_it2_ui_gesture_more = /** @type {(inputs: Ui_Gesture_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Più ${i?.label}`)
};

/**
* | output |
* | --- |
* | "More {label}" |
*
* @param {Ui_Gesture_MoreInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const ui_gesture_more = /** @type {((inputs: Ui_Gesture_MoreInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Gesture_MoreInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_ui_gesture_more(inputs)
	if (locale === "es-419") return es_419_ui_gesture_more(inputs)
	if (locale === "pt-PT") return pt_pt2_ui_gesture_more(inputs)
	if (locale === "fr-FR") return fr_fr2_ui_gesture_more(inputs)
	if (locale === "de-DE") return de_de2_ui_gesture_more(inputs)
	if (locale === "it-IT") return it_it2_ui_gesture_more(inputs)
	return en_us2_ui_gesture_more(inputs)
});
export { ui_gesture_more as "ui-gesture.more" }